// PreviewTester/components/Tour/TourSteps.js
export const TOUR_STEPS = {
  WELCOME: 0,
  EDIT_TEMPLATE: 1,
  CUSTOM_MESSAGE: 2,
  START_WIZARD: 3,
  SELECT_TEXT: 4,
  APPLY_TRANSFORMATION: 5,
  SAVE_CONFIGURATION: 6,
  COMPLETE: 7,
};

export const getWelcomeStep = () => ({
  id: TOUR_STEPS.WELCOME,
  type: 'modal',
  icon: '🚀',
  title: 'Welcome to Response Preview Tester!',
  description: 'Transform your API responses into beautiful, interactive previews. Let\'s take a quick tour to get you started.',
  buttonText: 'Let\'s Go!',
});

export const getEditTemplateStep = () => ({
  id: TOUR_STEPS.EDIT_TEMPLATE,
  type: 'tooltip',
  targetId: 'edit-template-btn',
  icon: '✏️',
  title: 'Edit Your Template',
  description: 'Click here to open the template editor. You can add, delete, or modify rows to customize your preview.',
  position: 'bottom',
});

export const getCustomMessageStep = () => ({
  id: TOUR_STEPS.CUSTOM_MESSAGE,
  type: 'tooltip',
  targetId: 'custom-message-btn',
  icon: '💬',
  title: 'Add Custom Messages',
  description: 'Add custom messages to your template using the "+ Custom Message" button. Use @ to insert variables from your data.',
  position: 'bottom',
});

export const getStartWizardStep = () => ({
  id: TOUR_STEPS.START_WIZARD,
  type: 'tooltip',
  targetId: 'start-wizard-btn',
  icon: '🧙',
  title: 'Start the Transformation Wizard',
  description: 'Click here to start the transformation wizard. This will guide you through applying transformations to your preview.',
  position: 'bottom',
});

export const getSelectTextStep = () => ({
  id: TOUR_STEPS.SELECT_TEXT,
  type: 'tooltip',
  targetId: 'preview-container',
  icon: '👆',
  title: 'Select Text to Transform',
  description: 'Click and drag to select any text in the preview. The wizard will show you available transformations for your selection.',
  position: 'bottom',
});

export const getApplyTransformationStep = () => ({
  id: TOUR_STEPS.APPLY_TRANSFORMATION,
  type: 'tooltip',
  targetId: 'transformation-popup',
  icon: '✨',
  title: 'Apply Transformations',
  description: 'Choose from Structural, Media, or Style transformations. Each one will instantly transform your selected text.',
  position: 'top',
});

export const getSaveConfigurationStep = () => ({
  id: TOUR_STEPS.SAVE_CONFIGURATION,
  type: 'tooltip',
  targetId: 'save-config-btn',
  icon: '💾',
  title: 'Save Your Configuration',
  description: 'Once you\'re happy with your transformations, click here to save everything to the backend.',
  position: 'left',
});

export const getCompleteStep = () => ({
  id: TOUR_STEPS.COMPLETE,
  type: 'modal',
  icon: '🎉',
  title: 'You\'re All Set!',
  description: 'You\'ve completed the tour! Now you can create powerful response previews with ease.',
  buttonText: '🎉 Start Building!',
});